module.exports = __webpack_public_path__ + "static/img/W.7c6c632.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/W.png
// module id = hbg6
// module chunks = 0